import instance from 'utils/axios/instance.axios';
import { PERSONNEL_ADJUSTMENT } from './_constant';

export const createPersonnelAdjustment = async (data = {}) =>
  instance.post(PERSONNEL_ADJUSTMENT.CREATE, data);

export const editPersonnelAdjustment = async ({ personnelAdjustmentId, data }) =>
  instance.post(PERSONNEL_ADJUSTMENT.UPDATE(personnelAdjustmentId), data);

export const deletePersonnelAdjustment = async (id) =>
  instance.delete(PERSONNEL_ADJUSTMENT.DELETE(id));

export const submitPersonnelAdjustment = async (id) =>
  instance.post(PERSONNEL_ADJUSTMENT.SUBMIT(id));

export const getPersonnelAdjustmentById = (id) => instance.get(PERSONNEL_ADJUSTMENT.GET_BY_ID(id));

export const getPersonnelAdjustmentByProjectId = (projectId) =>
  instance.get(PERSONNEL_ADJUSTMENT.GET_BY_PROJECT_ID(projectId));

export const downloadPersonnelAdjustmentDocxFile = (id) =>
  instance.get(PERSONNEL_ADJUSTMENT.DOWNLOAD_DOCX_FILE(id), { responseType: 'blob' });

export const downloadPersonnelAdjustmentPdfFile = (id) =>
  instance.get(PERSONNEL_ADJUSTMENT.DOWNLOAD_PDF_FILE(id), { responseType: 'blob' });
